import React from 'react';

import './style.scss';

interface WinnersSkeletonProps {
  cards?: number;
}

export const WinnersSkeleton: React.FC<WinnersSkeletonProps> = ({ cards = 6 }) => {
  return (
    <div className="skeleton">
      <div className="skeletonList">
        {Array.from({ length: cards }).map((_, index) => (
          <div className="skeletonCard" key={index}>
            <span className="skeletonCardThumb" />
            <div className="skeletonCardInfo">
              <span className="skeletonLine skeletonLineLg" />
              <span className="skeletonLine skeletonLineMd" />
              <span className="skeletonLine skeletonLineSm" />
            </div>
            <div className="skeletonCardStats">
              <span className="skeletonLine skeletonLineTop" />
              <span className="skeletonLine skeletonLineBottom" />
            </div>
            <span className="skeletonCardBtn" />
          </div>
        ))}
      </div>
    </div>
  );
};

